import { RoomBaseApiService } from '@/core/service/room.baseapi.service'
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomUserService extends RoomBaseApiService {
    async getMyNickname(roomId) {
        try {
            const response = await this.request().get(
                `/api/v3/room/${roomId || this.getRoomId()}/users/myNickname`
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getRoomUserList() {
        try {
          const response = await this.request().get(
            `/api/v3/room/${this.getRoomId()}/users`
          )
          return new ResponseWrapper(response, response.data.data)
        } catch (error) {
          throw new ErrorWrapper(error)
        }
    }

    async getAbsenceRoomUserList() {
        try {
          const response = await this.request().get(
            `/api/v3/room/${this.getRoomId()}/absenceRoomUserList`
          )
          return new ResponseWrapper(response, response.data.data)
        } catch (error) {
          throw new ErrorWrapper(error)
        }
    }

    async changeUserDeviceStatus(userId, deviceType, deviceStatus) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/device`,
              { userId, deviceType, deviceStatus }
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
          throw new ErrorWrapper(error)
        }
    }

    async changeUserDeviceStatusAll(deviceType, deviceStatus) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/device/all`,
                { deviceType, deviceStatus }
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeUserRole(userId, roleType, roleStatus) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/role`,
                { userId, roleType, roleStatus }
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeUserRoleAll(roleType, roleStatus) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/role/all`,
                { roleType, roleStatus }
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

  async changeRoomUserNickname(userId, nickname) {
    try {
        const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/nickname`,
          { userId, nickname }
        )
        return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async setUserNickname(userId, nickname) {
    try {
        // const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/nickname/set`,
        //   { userId, nickname }
        // )
        // return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeAllUserAuthStatus(type) {
    try {
        const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/all/device`,
          { type }
        )
        return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async kickRoomUser(params) {
      try {
          const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/kick`, {
              ...params
          })
          return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          throw new ErrorWrapper(error)
      }
  }

  async kickAllRoomUser() {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/kickAll`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getUserProfileUrl(userId) {
      try {
          const response = await this.request().post(
              `/api/v3/lecture/${userId}/users/profile`
          )

          let sasUrl = response.data.data;
          if(!sasUrl) return new ResponseWrapper(response, {url : ''})

          try{
              let res = await this.request({auth: false}).get(sasUrl, {
                  responseType: 'blob',
                  withCredentials: false
              });
              let url = URL.createObjectURL(new Blob([res.data]));

              return new ResponseWrapper(response, {url})
          }catch(e){
              return new ResponseWrapper(response, {url : ''})
          }
      } catch (error) {
          throw new ErrorWrapper(error)
      }
  }

  async getUserPhone(userId) {
    try {
      const response = await this.request().get(`/api/v3/lecture/${this.getRoomId()}/users/${userId}/phone`)

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getRoomUserRollBook() {
    try {
      const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/users/roll-book`)
      let roomUserRollBook = response.data.data
      return new ResponseWrapper(response, roomUserRollBook)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeRoomUserRoleId({ userId, roleType }) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/roleId`,
        { userId, roleType }
      )
      let data = response.data.data
      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async requestSpeak() {
      try {
          const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/requestSpeak`)
          return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          throw new ErrorWrapper(error)
      }
  }
  async cancelRequestSpeak(reqSpeakId) {
      try {
          const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/cancelRequestSpeak`,
              {reqSpeakId}
          )
          return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          throw new ErrorWrapper(error)
      }
  }
  async confirmRequestSpeak({reqSpeakId, userId, reject}) {
      try {
          const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/users/confirmRequestSpeak`,
              {reqSpeakId, userId, reject}
          )
          return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          throw new ErrorWrapper(error)
      }
  }
    async getRoomUserAttendanceList() {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/attendance/list`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
    async changeUserVideoQuality(param) {
      try {
        const response = await this.request().get(
            `/api/v3/room/${this.getRoomId()}/users/${param.userId}/resolutions?resolution=${param.userVideoQuality}`
        )
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    async changeUserStatus(status) {
      try {
        const response = await this.request().post(
            `/api/v3/room/${this.getRoomId()}/users/changeUserStatus`,
            {status}
        )
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

  async sendNetworkStatus({ roomUser, levelObj }) {
    try {
      const response = await this.request().get(
        `/api/v3/room/${this.getRoomId()}/users/${roomUser.userId}/networkStatus`, {
          params: levelObj
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

    async getSpeakerUser() {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/users/speaker`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const roomUserService = new RoomUserService()
